export default __webpack_public_path__ + "static/media/high-level.e502e6c8.png";